import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import { Fab, Tooltip } from '@mui/material'
import styled from 'styled-components/macro'

interface Props {
  expanded: boolean
  position: 'left' | 'right'
  children: React.ReactNode
  onToggleOpen?: any
}

export const Sidebar = ({ expanded, position, children, onToggleOpen }: Props) => {
  return (
    <StyledSidebar expanded={expanded} position={position}>
      <OverflowWrapper expanded={expanded} position={position}>
        <SidebarContents position={position}>{children}</SidebarContents>
      </OverflowWrapper>
      <SidebarToggle position={position} expanded={expanded} onClick={onToggleOpen} />
    </StyledSidebar>
  )
}

const SidebarToggle = ({
  position,
  expanded,
  onClick,
}: {
  position: 'left' | 'right'
  expanded: boolean
  onClick?: any
}) => (
  <Tooltip title={expanded ? 'Close sidebar' : 'Open sidebar'} placement={position === 'left' ? 'right' : 'left'}>
    <Fab
      size="small"
      sx={{
        position: 'absolute',
        bottom: 20,
        right: position === 'left' ? '-60px' : 'unset',
        left: position === 'right' ? '-60px' : 'unset',
        color: '#444',
        transform: expanded ? 'rotateY(0deg)' : 'rotateY(180deg)',
        zIndex: 900,
      }}
      onClick={onClick}
    >
      {position === 'left' ? <ChevronLeft /> : <ChevronRight />}
    </Fab>
  </Tooltip>
)

const StyledSidebar = styled.div<{ expanded?: boolean; position?: 'left' | 'right' }>`
  position: relative;
  height: calc(100vh - 50px);
  width: ${({ expanded }) => (!expanded ? 0 : 250)}px;
  transition: 300ms width ease;
  background: white;
  ${({ position }) => (position === 'left' ? 'border-right' : 'border-left')}: 1px solid #e5e5e5;
`

const OverflowWrapper = styled.div<{ position: 'left' | 'right'; expanded?: boolean }>`
  position: relative;
  height: 100%;
  float: ${({ position }) => (position === 'left' ? 'right' : 'left')};
  overflow: ${({ expanded }) => (expanded ? 'visible' : 'hidden')};
`

const SidebarContents = styled.div<{ expanded?: boolean; position?: 'left' | 'right' }>`
  width: 250px;
`

export const SidebarDivision = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px #dddddd solid;
`

export const SidebarElementX = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 14px;
  width: 100%;
`
